import {
    updateCriminalRecord,
    updateCurrentAddress,
    updateInformedConsent,
    updatePersonalInformation,
    updatePreviousAddress,
    updateReasonForCRV,
    updateIdVerification,
    updatePhotoVerification,
} from "../../../redux/slice/personalBackgrountCheckSlice"
import { Formik, Form, Field, ErrorMessage } from "formik"
import * as Yup from "yup"
import { useDispatch, useSelector } from "react-redux"
import { Upload, message, Image } from "antd"
import { UploadOutlined } from "@ant-design/icons"
import { useState } from "react"
import axios from "axios"
import { setIsLoading } from "../../../redux/slice/appSlice"
import PdfGenerator from "./pdfGenerator"
import { LuShieldCheck } from "react-icons/lu"
import photoCheckImg from "../../../OIFendImages/images/backgroundCheck/photoVerification.jpeg"
import { CameraCaptureModal } from "./camera-capture-modal"

const PhotoVerificationSchema = Yup.object().shape({
    photoVerification: Yup.object().shape({
        photoOne: Yup.string().required("ID One is required"),
        photoTwo: Yup.string(),
    }),
})

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
    })

export const PhotoVerification = ({ prevStep, gofirstStep }) => {
    const [triggerPdf, setTriggerPdf] = useState(false)
    const [isCameraOpen, setIsCameraOpen] = useState(false)
    const [currentPhotoField, setCurrentPhotoField] = useState(null)

    const dispatch = useDispatch()
    const photoVerification = useSelector((state) => state.backgroundCheck.photoVerification)
    const idVerification = useSelector((state) => state.backgroundCheck.idVerification)
    const isLoading = useSelector((state) => state.isLoading)

    const initialValues = {
        photoVerification: {
            photoOne: photoVerification?.photoOne || "",
            photoTwo: photoVerification?.photoTwo || "",
        },
    }

    const handleUpload = async (info, setFieldValue, fieldName) => {
        const file = info.file.originFileObj || info.file
        const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png"
        const isLt3M = file.size / 1024 / 1024 < 3

        if (!isJpgOrPng) {
            message.error("You can only upload JPG/PNG files!")
            return
        }
        if (!isLt3M) {
            message.error("File must be smaller than 3MB!")
            return
        }

        try {
            const base64 = await getBase64(file)
            setFieldValue(`photoVerification.${fieldName}`, base64)
            dispatch(
                updatePhotoVerification({
                    ...photoVerification,
                    [fieldName]: base64,
                }),
            )
        } catch (error) {
            console.error("Error converting file to Base64:", error)
        }
    }

    const handleSubmit = (values, { setFieldValue }) => {
        dispatch(setIsLoading(true))
        dispatch(updatePhotoVerification(values.photoVerification))
        setTriggerPdf(true)
        console.log("Submitted Values:", values)
    }

    const handlePdfGenerated = async (PDFbase64) => {
        await sendEmail(PDFbase64)
    }

    const sendEmail = async (PDFbase64) => {
        const formData = new FormData()

        // Subject and HTML body
        formData.append("subject", "Meta Force Background Check Form")
        formData.append("body", `<p>Thank you for your submission! Please find the details attached.</p>`)

        // Helper: Convert base64 data to a Blob
        const base64ToBlob = (base64, mime) => {
            const byteCharacters = atob(base64)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            return new Blob([byteArray], { type: mime })
        }

        // Attach main PDF
        formData.append("attachment", base64ToBlob(PDFbase64, "application/pdf"), "form-submission.pdf")

        // Additional attachments (IDs)
        const files = [
            { name: "ID-One.jpg", content: idVerification.idOne },
            { name: "ID-Two.jpg", content: idVerification.idTwo },
            { name: "Additional-ID.jpg", content: idVerification.additionalId },
            { name: "Photo-One.jpg", content: photoVerification.photoOne },
            { name: "Photo-Two.jpg", content: photoVerification.photoTwo },
        ]

        files.forEach((file) => {
            if (file.content) {
                const base64 = file.content.split(",")[1]
                const mime = file.content.split(";")[0].split(":")[1] || "image/jpeg"
                const blob = base64ToBlob(base64, mime)
                formData.append("attachment", blob, file.name)
            }
        })

        const config = {
            method: "post",
            url: "https://ddmp5a4cih.execute-api.us-east-1.amazonaws.com/metaforce-stage/submit",
            headers: {
                accept: "application/json",
                // No 'Content-Type' — let browser handle it
            },
            data: formData,
        }

        try {
            const response = await axios.request(config)
            message.success("Form is submitted successfully!")
            console.log("Email response:", response.data)
        } catch (error) {
            message.error("Failed to submit the form. Please try again.")
            console.error("Error sending email:", error)
        } finally {
            dispatch(setIsLoading(false))
            resetForm()
        }
    }

    const resetForm = () => {
        setTriggerPdf(false)

        dispatch(
            updatePersonalInformation({
                lastName: "",
                givenName: "",
                lastNameAtBirth: "",
                formerName: "",
                email: "",
                phoneNumber: "",
                birthPlace: "",
                dob: "",
                gender: "",
            }),
        )
        dispatch(
            updateCurrentAddress({
                houseNumber: "",
                streetName: "",
                unitNumber: "",
                city: "",
                province: "",
                postalCode: "",
                country: "",
            }),
        )
        dispatch(
            updatePreviousAddress([
                {
                    houseNumber: "",
                    streetName: "",
                    unitNumber: "",
                    city: "",
                    province: "",
                    postalCode: "",
                    country: "",
                },
            ]),
        )
        dispatch(
            updateReasonForCRV({
                reasonForRequest: "",
                organizationRequestingSearch: "",
                contactName: "",
                contactPhone: "",
            }),
        )
        dispatch(
            updateCriminalRecord({
                lastName: "",
                givenName: "",
                dob: "",
                offenceDetails: [
                    {
                        offence: "",
                        dos: "",
                        courtLocation: "",
                    },
                ],
            }),
        )
        dispatch(
            updateInformedConsent({
                searchAuthorization: false,
                policeInformationSystems: false,
                policeInfoSystems: {
                    CPICData: false,
                    PIO: false,
                    other: false,
                },
                AuthorizationWaiver: false,
                metaforceConsentSystems: false,
                ThirdPartyOrg: "",
                SignedAt: "",
                dateSigned: "",
                applicantSignature: "",
            }),
        )
        dispatch(
            updateIdVerification({
                idOne: "",
                idTwo: "",
                additionalId: "",
            }),
        )
        dispatch(
            updatePhotoVerification({
                photoOne: "",
                photoTwo: "",
            }),
        )
        gofirstStep(1)
    }

    const handleCapturedImage = (imageBase64, setFieldValue) => {
        if (!currentPhotoField) return
        setFieldValue(`photoVerification.${currentPhotoField}`, imageBase64)
        dispatch(updatePhotoVerification({ ...photoVerification, [currentPhotoField]: imageBase64 }))
        setIsCameraOpen(false)
        setCurrentPhotoField(null)
    }

    const handleOpenCamera = (fieldName) => {
        setCurrentPhotoField(fieldName)
        setIsCameraOpen(true)
    }

    return (
        <>
            <Formik initialValues={initialValues} validationSchema={PhotoVerificationSchema} onSubmit={handleSubmit}>
                {({ values, setFieldValue, validateField }) => (
                    <>
                        <Form>
                            <div className="px-6 py-4 bg-gray-20 border-b border-gray-300">
                                <h2 className="text-xl font-semibold text-gray-800 mb-0">Upload Your Photo for Verification</h2>
                            </div>
                            <div className="px-6 py-4 bg-gray-20">
                                <div className="flex flex-wrap -mx-3 mb-5">
                                    <div className="w-full md:w-3/4 px-3">
                                        <h2 className="text-lg font-medium">
                                            To verify your identity, please upload a clear photo of yourself holding your ID card.
                                        </h2>
                                        <div className="flex justify-start mb-1">
                                            <span className="text-md">
                                                <LuShieldCheck color="#24357C" className="mt-1" />
                                            </span>
                                            <div className="ml-3">
                                                <h4 className="text-sm font-small text-gray-800 mb-0">
                                                    Hold your ID card next to your face, making sure both your face and the ID are clearly
                                                    visible.
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="flex justify-start mb-1">
                                            <span className="text-md">
                                                <LuShieldCheck color="#24357C" className="mt-1" />
                                            </span>
                                            <div className="ml-3">
                                                <h4 className="text-sm font-small text-gray-800 mb-0">
                                                    Ensure the photo is well-lit and not blurry.
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="flex justify-start mb-1">
                                            <span className="text-md">
                                                <LuShieldCheck color="#24357C" className="mt-1" />
                                            </span>
                                            <div className="ml-3">
                                                <h4 className="text-sm font-small text-gray-800 mb-0">
                                                    The details on the ID must be readable — avoid glare or reflections.
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="flex justify-start mb-1">
                                            <span className="text-md">
                                                <LuShieldCheck color="#24357C" className="mt-1" />
                                            </span>
                                            <div className="ml-3">
                                                <h4 className="text-sm font-small text-gray-800 mb-0">
                                                    Only accepted IDs: Passport, Driver’s License, or National ID card.
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="flex justify-start mb-1">
                                            <span className="text-md">
                                                <LuShieldCheck color="#24357C" className="mt-1" />
                                            </span>
                                            <div className="ml-3">
                                                <h4 className="text-sm font-small text-gray-800 mb-0">
                                                    File formats allowed: JPG, PNG, or PDF (max size: 5 MB).
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full md:w-1/4 px-3">
                                        <img
                                            style={{ height: "175px" }}
                                            className="rounded-lg"
                                            src={photoCheckImg || "/placeholder.svg"}
                                            alt="Vortex"
                                        />
                                    </div>
                                </div>

                                {/* Photo One */}
                                <div className="flex flex-wrap -mx-3 mb-5">
                                    <div className="w-full md:w-1/4 px-3">
                                        <label
                                            htmlFor="photoVerification.photoOne"
                                            className="block text-gray-700 text-sm font-bold mb-2 ml-2"
                                        >
                                            Photo One
                                        </label>
                                        <Upload
                                            name="photoOne"
                                            beforeUpload={() => false}
                                            onChange={(info) =>
                                                handleUpload(info, setFieldValue, "photoOne").then(() =>
                                                    validateField("photoVerification.photoOne"),
                                                )
                                            }
                                            showUploadList={false}
                                        >
                                            <button
                                                type="button"
                                                className="upload-btn bg-gray-50 border rounded-full px-8 py-3 leading-tight focus:outline-none focus:bg-white mb-1"
                                            >
                                                <UploadOutlined /> Upload Photo One
                                            </button>
                                        </Upload>
                                        <button
                                            type="button"
                                            className="bg-blue-600 text-white rounded-full px-8 py-3 mb-4"
                                            onClick={() => handleOpenCamera("photoOne")}
                                        >
                                            Open Camera
                                        </button>
                                    </div>
                                    <div className="w-full md:w-3/4 px-3">
                                        {values.photoVerification.photoOne && (
                                            <div style={{ textAlign: "center", marginTop: "10px" }}>
                                                <Image
                                                    src={values.photoVerification.photoOne || "/placeholder.svg"}
                                                    alt="ID One Preview"
                                                    width={150}
                                                    style={{
                                                        borderRadius: "8px",
                                                        border: "1px solid #d9d9d9",
                                                        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                                                        padding: "5px",
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className="w-full md:w-1/1 px-3">
                                        <Field type="hidden" name="photoVerification.photoOne" />
                                        <ErrorMessage
                                            name="photoVerification.photoOne"
                                            component="div"
                                            className="text-red-500 text-xs italic ml-2"
                                        />
                                    </div>
                                </div>
                                {/* Photo Two */}
                                <div className="flex flex-wrap -mx-3 mb-5">
                                    <div className="w-full md:w-1/4 px-3">
                                        <label
                                            htmlFor="photoVerification.photoTwo"
                                            className="block text-gray-700 text-sm font-bold mb-2 ml-2"
                                        >
                                            Photo Two
                                        </label>
                                        <Upload
                                            name="photoTwo"
                                            beforeUpload={() => false}
                                            onChange={(info) => handleUpload(info, setFieldValue, "photoTwo")}
                                            showUploadList={false}
                                        >
                                            <button
                                                type="button"
                                                className="upload-btn bg-gray-50 border rounded-full px-8 py-3 leading-tight focus:outline-none focus:bg-white mb-1"
                                            >
                                                <UploadOutlined /> Upload ID Two
                                            </button>
                                        </Upload>
                                        <button
                                            type="button"
                                            className="bg-blue-600 text-white rounded-full px-8 py-3 mb-4"
                                            onClick={() => handleOpenCamera("photoTwo")}
                                        >
                                            Open Camera
                                        </button>
                                    </div>
                                    <div className="w-full md:w-3/4 px-3">
                                        {values.photoVerification.photoTwo && (
                                            <div style={{ textAlign: "center", marginTop: "10px" }}>
                                                <Image
                                                    src={values.photoVerification.photoTwo || "/placeholder.svg"}
                                                    alt="ID One Preview"
                                                    width={150}
                                                    style={{
                                                        borderRadius: "8px",
                                                        border: "1px solid #d9d9d9",
                                                        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                                                        padding: "5px",
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className="w-full md:w-1/1 px-3">
                                        <Field type="hidden" name="photoVerification.photoTwo" />
                                    </div>
                                </div>
                            </div>

                            {/* Navigation Buttons */}
                            <div className="px-6 py-4 bg-gray-20 border-t border-gray-300 flex justify-between">
                                <button
                                    type="submit"
                                    className="bgPrimaryColor uppercase text-white rounded-full px-8 py-3 text-center md:text-left hover:bg-blue-800 transform transition duration-500 relative focus:outline-none border-2 border-solid rounded-lg text-sm font-semibold tracking-widest"
                                >
                                    Submit
                                </button>
                                <button
                                    type="button"
                                    className="bg-gray-300 text-dark rounded-full px-8 py-3 shadow hover:bg-gray-300"
                                    onClick={prevStep}
                                >
                                    Back
                                </button>
                            </div>
                        </Form>
                        <CameraCaptureModal
                            open={isCameraOpen}
                            onClose={() => {
                                setIsCameraOpen(false)
                                setCurrentPhotoField(null)
                            }}
                            onCapture={(img) => handleCapturedImage(img, setFieldValue)}
                        />
                    </>
                )}
            </Formik>
            <PdfGenerator triggerPdf={triggerPdf} onPdfGenerated={handlePdfGenerated} />
        </>
    )
}
